export const TEMPLATES_LIST_KEY = 'TEMPLATES_LIST';
export const TEMPLATES_ONE_KEY = 'TEMPLATES_ONE_KEY';
export const TEMPLATE_SECTIONS_LIST_KEY = 'TEMPLATE_SECTIONS_LIST';
export const TEMPLATE_SECTIONS_ONE_KEY = 'TEMPLATE_SECTIONS_ONE_KEY';
export const TEMPLATE_ITEMS_LIST_KEY = 'TEMPLATE_ITEMS_LIST_KEY';
export const TEMPLATE_ITEMS_ONE_KEY = 'TEMPLATE_ITEMS_ONE_KEY';
export const TEMPLATE_ANSWER_LIST_KEY = 'TEMPLATE_ANSWER_LIST_KEY ';
